<div>
  <div bsModal #addDateModal="bs-modal" class="modal" tabindex="-1" role="dialog">
    <div class="modal-dialog modal-lg" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h4 class="modal-title">Add Date</h4>
        </div>
        <div class="modal-body">
          <div class="form-group">
            <app-datepicker-input
              *ngIf="!this.loading"
              [inputLabel]="'Due Date'"
              [formControl]="addDateForm.get('dueDate')"></app-datepicker-input>
          </div>

          <br />

          <div style="text-align: right">
            <button type="button" class="btn aru btn-secondary" (click)="cancel()">Close</button>
            <button type="button" class="btn aru btn-primary ml-2" (click)="save()">Save changes</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
